<template>
  <g
    :class="{'wire-group': true, 'selected': selected}"
    :id="groupid"
    @click="onClick()"
    >
    <component
      v-for="(data, index) in wires"
      :is="'Wire'"
      :key="index"
      :data="data"
    />
  </g>
</template>

<script>
import Wire from './Wire.vue'
import store from '../../../../store/index.js'

export default {
  components: { Wire },
  props: ['id', 'wires'],
  data () {
    return {
      code: `WL-${this.id < 10 ? '0' + this.id : this.id}`,
      selected: false,
      bbox: null
    }
  },
  computed: {
    groupid () {
      return `wire-group${this.id}`
    }
  },
  methods: {
    onClick () {
      if (store.state.isSimulating) return
      this.selected = !this.selected
      if (!this.bbox) this.bbox = this.$el.getBBox()
      const obj = { el: this.$el, id: this.groupid }
      if (this.selected) {
        store.commit('elct/addSelectedElct', obj)
      } else {
        store.commit('elct/removeSelectedElct', obj)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.highlight {
  -webkit-filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
  filter: drop-shadow( 0px 0px 5px rgba(0, 0, 255, 0.7));
}
</style>
